import { Box, Heading, Separator } from "@twilio-paste/core";
import React from "react";
import { Example } from "../../shared/components";

export interface IconDetailsSection {
    examples: string[];
    description: string;
    docName: string;
}
type IconDetailsProps = {
    sections: Array<IconDetailsSection>;
};
function IconDetails({ sections }: IconDetailsProps) {
    return (
        <Box>
            {sections.map((section: IconDetailsSection, sectionIdx: number) => {
                const sectionId = `icon-section-${section.docName.toLowerCase().split(" ").join("-")}`;
                return (
                    <Box key={sectionId} as="div" data-testid={sectionId}>
                        <Heading as="h1" variant="heading10">
                            {section.docName}
                        </Heading>
                        {section.examples.map((example: string, exampleIdx: number) => {
                            const iconExampleId = `${sectionId}-example-${exampleIdx}`;
                            return <Example key={iconExampleId} example={example} description={section.description} />;
                        })}
                    </Box>
                );
            })}
            <Separator orientation="horizontal" verticalSpacing="space50" />
        </Box>
    );
}

export default IconDetails;
